import { call, CallEffect, ForkEffect, put, PutEffect, takeLatest } from 'redux-saga/effects';

import { MARKETPLACE_PRODUCT_LIST_REQUEST, MARKETPLACE_PRODUCT_REQUEST, MARKETPLACE_MTRACK_CONSENT_DATA_REQUEST } from './marketplace-constants';

import { getMarketplaceProduct, getMarketplaceProductList, getMarketplaceMTrackConsentData } from './marketplace-api';

import { apiErrorGeneric } from '../api-errors';
import { ProductRequestAction, marketplaceProductFailure, marketplaceProductListFailure, marketplaceProductListSuccess, marketplaceProductSuccess, marketplaceMTrackConsentDataSuccess, marketplaceMTrackConsentDataFailure } from './marketplace-actions';

export function* getMarketplaceProductSaga(action: ProductRequestAction): Generator<PutEffect | CallEffect> {
  try {
    const data: any = yield call(getMarketplaceProduct, action.payload.id);
    if (data.status === 200) {
      yield put(marketplaceProductSuccess(data));
    } else {
      throw Error;
    }
  } catch {
    yield put(marketplaceProductFailure(apiErrorGeneric));
  }
}

export function* getMarketplaceProductSagaWatcher(): Generator<ForkEffect> {
  yield takeLatest(MARKETPLACE_PRODUCT_REQUEST, getMarketplaceProductSaga);
}

export function* getMarketplaceProductListSaga(): Generator<PutEffect | CallEffect> {
  try {
    const data: any = yield call(getMarketplaceProductList);
    if (data.status === 200) {
      yield put(marketplaceProductListSuccess(data));
    } else {
      throw Error;
    }
  } catch {
    yield put(marketplaceProductListFailure(apiErrorGeneric));
  }
}

export function* getMarketplaceProductListSagaWatcher(): Generator<ForkEffect> {
  yield takeLatest(MARKETPLACE_PRODUCT_LIST_REQUEST, getMarketplaceProductListSaga);
}

export function* getMTrackConsentDataSagaWatcher(): Generator<ForkEffect> {
  yield takeLatest(MARKETPLACE_MTRACK_CONSENT_DATA_REQUEST, getMTrackConsentDataSaga);
}

export function* getMTrackConsentDataSaga(): Generator<PutEffect | CallEffect> {
  try {
    const data: any = yield call(getMarketplaceMTrackConsentData);
    if (data.status === 200) {
      yield put(marketplaceMTrackConsentDataSuccess(data));
    } else {
      throw Error;
    }
  } catch {
    yield put(marketplaceMTrackConsentDataFailure(apiErrorGeneric));
  }
}
